"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformData = void 0;
const payments_pdf_generation_1 = require("../../constants/payments-pdf-generation");
class TransformData {
}
exports.TransformData = TransformData;
TransformData.convertDate = (dateNumber) => {
    if (dateNumber !== 0) {
        let dateString = `${dateNumber}`;
        dateString = `${dateString.substring(0, 4)}-${dateString.substring(4, 6)}-${dateString.substring(6, 8)}`;
        return new Date(dateString);
    }
    else {
        return null;
    }
};
TransformData.numberToUSDString = (currency) => {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });
    return formatter.format(currency);
};
TransformData.formatDateCustom = (dateInput, format = payments_pdf_generation_1.DATE_FORMAT) => {
    const date = new Date(dateInput);
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();
    return format
        .replace("yyyy", year.toString())
        .replace("M", month.toString())
        .replace("d", day.toString());
};
TransformData.formatTransactionName = (t) => {
    const secondaryTransaction = t.hasSecondaryTransaction
        ? `${t.transactionTypeString} #${t.secondaryTransactionNumber} `
        : "";
    return (secondaryTransaction +
        `${t.isr && !t.hasSecondaryTransaction
            ? `${t.transactionTypeString} #${t.transactionNumber}`
            : (!t.isr || t.hasSecondaryTransaction) && t.transactionNumber !== "0"
                ? `Invoice #${t.transactionNumber}`
                : ""}`);
};
TransformData.capitalizeFirstLetterOfEachWord = (input) => {
    return input
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
};
TransformData.isValidTransactionNumber = (x) => {
    return x !== "0" && !!x;
};
